/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M10.3773.447a3.7498 3.7498 0 0 1 3.2454 0l9.3237 4.4753c1.3236.6354 1.3236 2.52 0 3.1554L20.504 9.25l2.4424 1.1723c1.3236.6354 1.3236 2.52 0 3.1554L20.504 14.75l2.4424 1.1723c1.3236.6354 1.3236 2.52 0 3.1554l-9.3237 4.4753a3.7497 3.7497 0 0 1-3.2454 0l-9.3237-4.4753c-1.3236-.6354-1.3236-2.52 0-3.1554L3.496 14.75l-2.4424-1.1723c-1.3236-.6354-1.3236-2.52 0-3.1554L3.496 9.25 1.0536 8.0777c-1.3236-.6354-1.3236-2.52 0-3.1554L10.3773.447ZM5.2292 15.5819l-3.5265 1.6927c-.189.0908-.189.36 0 .4508l9.3237 4.4753a2.2493 2.2493 0 0 0 1.9472 0l9.3237-4.4753c.1891-.0908.1891-.36 0-.4508l-3.5265-1.6927-5.1481 2.4711a3.7497 3.7497 0 0 1-3.2454 0l-5.1481-2.4711Zm8.3935-3.0289 5.1481-2.4711 3.5265 1.6927c.1891.0908.1891.36 0 .4508l-9.3237 4.4753a2.2493 2.2493 0 0 1-1.9472 0l-9.3237-4.4753c-.189-.0908-.189-.36 0-.4508l3.5265-1.6927 5.1481 2.4711a3.7497 3.7497 0 0 0 3.2454 0Z"
    clipRule="evenodd"
  />,
  'MenuEnvironmentsFilled'
);
